import React, { useState } from 'react';
import { ChallengeDescriptionSection } from 'src/types/shared/Challenge';

const Accordion: React.FC<AccordionProps> = ({ data }) => {
    const [currentIndex, setCurrentIndex] = useState<number | null>(null);
    return (
        <div className="accordion">
            {data.contents.map((item, i) => (
                <div
                    key={i}
                    onClick={() =>
                        currentIndex !== i ? setCurrentIndex(i) : setCurrentIndex(null)
                    }
                    className={`accordion-item icon ${currentIndex === i ? 'expanded' : ''}`}
                >
                    <h4>{item.title}</h4>
                    {currentIndex === i && (
                        <>
                            {!item.content ? (
                                <p>-</p>
                            ) : (
                                <p dangerouslySetInnerHTML={{ __html: item.content }} />
                            )}
                        </>
                    )}
                    <i
                        className={`icon fas fa-fw fa-caret-${currentIndex === i ? 'up' : 'down'}`}
                    />
                </div>
            ))}
        </div>
    );
};

interface AccordionProps {
    data: ChallengeDescriptionSection;
}

export default Accordion;
